import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { ProviderInterface } from '../../store/callrecorder/providersSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.providerPath(value.id)
  };
}

export const providersEntity = new schema.Entity(
  'providers',
  {},
  {
    processStrategy
  }
);

export const providerEntity = new schema.Entity(
  'provider',
  {},
  {
    processStrategy
  }
);

const fetchProvidersCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      providers: { [key: string]: ProviderInterface };
    }
  >(response.data.providers, [providersEntity]);

  return {
    providers: normalized.entities?.providers || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { provider: ProviderInterface; }
  >(response.data.provider, providerEntity);
  return normalized.entities;
}

export const fetchProviders = createAsyncThunk(
  `${PREFIX}_providers/fetchProviders`,
  async (params: object = {}) => fetchProvidersCollection('/onesky/providers', params)
);

export const fetchProvider = createAsyncThunk(
  `${PREFIX}_providers/fetchProvider`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/providers/${id}`);
    return normalizeInstance(response);
  }
);

export const createProvider = createAsyncThunk(
  `${PREFIX}_providers/createProvider`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.post(`/onesky/providers`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateProvider = createAsyncThunk(
  `${PREFIX}_providers/updateProvider`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/providers/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
